import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=43f26a26&"
import script from "./Register.vue?vue&type=script&lang=ts&"
export * from "./Register.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseRadio: require('/app/components/base/Radio.vue').default,BaseFormItem: require('/app/components/base/FormItem.vue').default,BaseInput: require('/app/components/base/Input.vue').default,BaseSelect: require('/app/components/base/Select.vue').default,BaseCheckbox: require('/app/components/base/Checkbox.vue').default,BaseForm: require('/app/components/base/Form.vue').default,AppNoty: require('/app/components/app/Noty.vue').default,BaseButton: require('/app/components/base/Button.vue').default})
